<script>
  import QuestionsForm from '../components/questions-form'
  import QuestionFieldSub from '../components/question-field-sub'
 
  export default {
    extends: QuestionsForm,
    template: '#questions-form-sub-template',
    name: 'QuestionsFormSub',
    components: {
      'question-field-sub': QuestionFieldSub,
    },
  }
</script>
